import React from "react";
import { Avatar, Card, List, Typography } from "antd/";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  selectGroupByKey,
  selectStudentsByGroupKey
} from "../../../redux/selectors/groups";
import { removeStudentFromGroup } from "../../../redux/actions/groups";
import { selectGroupActivities } from "../../../redux/selectors/actividades";
import CustomComment from "../Comment";

const PreguntaRenderer = props => {
  return Object.values(props.actividad.preguntas || {}).map((pregunta, i) => {
    return (
      <Card
        key={i}
        type="inner"
        title={
          <Typography.Title level={3}>
            {pregunta.tituloActividad}
          </Typography.Title>
        }
        style={{ marginBottom: 16 }}
      >
        {pregunta.descripcionActividad}
        {pregunta.preguntas && pregunta.tipoActividad !== "transfer" && (
          <CustomComment
            tipoActividad={pregunta.tipoActividad}
            preguntaIndex={i}
            pregunta={pregunta}
            {...props}
          />
        )}
      </Card>
    );
  });
};

class InfoGrupo extends React.PureComponent {
  render() {
    const { actividades, group, students } = this.props;

    return (
      <React.Fragment>
        <Card>
          <Card
            title={
              <Typography.Title level={2}>
                Preguntas y respuestas
              </Typography.Title>
            }
          >
            {actividades.map((actividad, i) => {
              if (actividad.transfer) {
                return (
                  <Card key={i}>
                    <PreguntaRenderer
                      key={i}
                      actividad={Object.values(actividad)[0]}
                    />
                    <List
                      bordered
                      header={
                        <React.Fragment>
                          <Typography.Title level={3}>
                            Grupo: {group.nombreGrupo}
                          </Typography.Title>
                          <Typography.Paragraph level={2}>
                            Colegio: {group.colegio}
                          </Typography.Paragraph>
                        </React.Fragment>
                      }
                      dataSource={students}
                      size="small"
                      renderItem={(item, i) => (
                        <List.Item key={i}>
                          <List.Item.Meta
                            avatar={<Avatar icon="user" />}
                            title={item.nombre}
                          />
                        </List.Item>
                      )}
                    />
                  </Card>
                );
              }
              return (
                <PreguntaRenderer key={i} actividad={actividad} group={group} />
              );
            })}
          </Card>
        </Card>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ removeStudentFromGroup }, dispatch);

const mapStateToProps = (state, ownProps) => {
  const groupId = ownProps.computedMatch.params.id || "-L_hTyzt0I9fQmI_uKMC";
  const group = selectGroupByKey(state, groupId) || { key: "" };
  const students = selectStudentsByGroupKey(state, groupId);
  const transfer = selectGroupActivities(
    state,
    group.key,
    "transfer",
    group.nivel
  );
  const trivia = selectGroupActivities(state, group.key, "trivia", group.nivel);
  const casillas = selectGroupActivities(
    state,
    group.key,
    "casillas",
    group.nivel
  );
  const upload = selectGroupActivities(state, group.key, "upload", group.nivel);
  const setItem = selectGroupActivities(
    state,
    group.key,
    "setItem",
    group.nivel
  );

  const actividades = [transfer, trivia, casillas, upload, setItem];

  return {
    group,
    actividades,
    students
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoGrupo);
